module.exports = __webpack_public_path__ + "media/images/athletes/3593-796ccf77febcc5b8d27aaef10aa9e496.png";